/**
 * Official Apple "Download on the App Store" badge (black variant).
 *
 * Rendered as unmodified inline SVG per Apple Marketing Resources guidelines:
 *   https://developer.apple.com/app-store/marketing/guidelines/
 *
 * DO NOT modify colors, add borders, gradients, effects INSIDE the badge,
 * or alter proportions. Container-level styling (drop shadow, hover lift,
 * scale) is permitted since it does not modify the badge artwork itself.
 *
 * Minimum height per guidelines: 40px on web.
 */
export default function AppStoreBadge({ height = 56, className = "", ariaLabel = "Download on the App Store" }) {
  // Aspect ratio 120:40 = 3:1
  const width = (height * 120) / 40;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 120 40"
      width={width}
      height={height}
      role="img"
      aria-label={ariaLabel}
      className={className}
    >
      <rect width="120" height="40" rx="6.5" fill="#000" />
      <rect
        x="0.5"
        y="0.5"
        width="119"
        height="39"
        rx="6"
        fill="none"
        stroke="#A6A6A6"
        strokeWidth="0.2"
      />

      {/* Apple logo — official glyph, white */}
      <g transform="translate(9.5, 8.5)" fill="#fff">
        <path d="M13.05 11.4c-.02-2.24 1.83-3.32 1.91-3.37-1.04-1.52-2.66-1.73-3.24-1.75-1.38-.14-2.69.81-3.39.81-.71 0-1.79-.79-2.94-.77-1.51.02-2.9.88-3.68 2.23-1.57 2.72-.4 6.74 1.13 8.95.75 1.08 1.63 2.3 2.79 2.25 1.12-.04 1.55-.72 2.9-.72 1.36 0 1.74.72 2.93.7 1.21-.02 1.97-1.1 2.71-2.19.85-1.26 1.2-2.48 1.22-2.54-.03-.01-2.35-.9-2.37-3.6zM10.85 4.83c.62-.75 1.04-1.79.92-2.83-.9.04-1.99.6-2.63 1.35-.57.66-1.08 1.72-.94 2.74 1 .07 2.02-.51 2.65-1.26z" />
      </g>

      {/* Text — official Apple typography stack. "Download on the" (small) + "App Store" (large) */}
      <text
        x="32"
        y="17"
        fill="#fff"
        fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif"
        fontSize="7.5"
        fontWeight="400"
      >
        Download on the
      </text>
      <text
        x="32"
        y="30"
        fill="#fff"
        fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif"
        fontSize="16"
        fontWeight="600"
        letterSpacing="-0.3"
      >
        App Store
      </text>
    </svg>
  );
}
